import { forwardRef } from "react"
import { Button, type ButtonProps } from "@/components/ui/primitives"
import { cn } from "@/lib/utils"

/**
 * Иконка рядом с текстом композера. Без рамки: подложка появляется по наведению,
 * как у кнопки диктовки. Состояние (запись, открытое меню) приходит через className.
 */
export const ComposerIconButton = forwardRef<HTMLButtonElement, ButtonProps>(function ComposerIconButton(
  { className, type = "button", variant = "ghost", size = "sm", ...props },
  ref,
) {
  return (
    <Button
      ref={ref}
      type={type}
      variant={variant}
      size={size}
      className={cn("h-8 w-7 shrink-0 rounded-lg p-0 hover:bg-ui-surface-hover", className)}
      {...props}
    />
  )
})
